import orderBy from 'lodash/orderBy'
import type { ScheduleEvent, Team } from '~/types'
import { LinkType, POST_GAME_STATUSES, PRE_GAME_STATUSES } from '~/enums/schedule-event'

export const useScheduleEventLinks = (
  status: MaybeRef<Maybe<ScheduleEvent.Status>>,
  links: MaybeRef<ScheduleEvent.Link[]>,
  team?: MaybeRef<Team.Model>,
) => {
  const filteredLinks = computed<ScheduleEvent.Link[]>(() => {
    let filteredLinks = unref(links).filter(filterByStatus)

    if (unref(team)) {
      filteredLinks = filteredLinks.filter(filterByTeam)
    }

    return orderBy(filteredLinks, 'order')
  })

  const filterByStatus = (link: ScheduleEvent.Link): boolean => {
    const rawStatus = unref(status)
    switch (link.type) {
      case LinkType.PostEvent:
        return null !== rawStatus && POST_GAME_STATUSES.includes(rawStatus)
      case LinkType.PreEvent:
        return null !== rawStatus && PRE_GAME_STATUSES.includes(rawStatus)
      case LinkType.Recap:
        return true
      default:
        return false
    }
  }

  const filterByTeam = (link: ScheduleEvent.Link): boolean => {
    if (!link.teamId) {
      return true
    }

    const teamId = unref(team)?.id || null
    return link.teamId === teamId
  }

  const hasLinks = computed<boolean>(() => filteredLinks.value && filteredLinks.value.length > 0)

  return {
    filteredLinks,
    hasLinks,
  }
}
